// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__Aq-Dm","label":"CategoryService_label__2Ayo_","location":"CategoryService_location__8n1tt"};